import { f7 } from 'framework7-react';
import { useState } from 'react';
import { requestPasswordResetApi } from '@/api/authApi';
import { useToast } from '@/hooks/useToast';
import {
  RequestPasswordResetApiParams,
  RequestPasswordResetApiResponse,
} from '@/types/api/authApi';

export const usePasswordReset = () => {
  const [data, setData] = useState<RequestPasswordResetApiResponse['data']>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>();
  const { openToast } = useToast();

  const resetPassword = async (params: RequestPasswordResetApiParams) => {
    try {
      f7.preloader.show();
      setIsLoading(true);
      const { data } = await requestPasswordResetApi(params);
      setData(data);
      if (!data.success) {
        throw new Error(data.error?.message);
      }
    } catch (e: unknown) {
      if (e instanceof Error) {
        openToast(e.message, 'toast-failed');
      }
      setError(e);
    } finally {
      setIsLoading(false);
      f7.preloader.hide();
    }
  };

  return {
    resetPassword,
    data,
    isLoading,
    error,
  };
};
